/**
 * 
 * key
 * 
 */


const key = 'cmV0b3VjaFRlYW1Qcm9kdWN0aXZpdHk='

export default key 